var map = {
	"./de/impressum.mdx": [
		35327,
		35327
	],
	"./de/index.mdx": [
		89409,
		89409
	],
	"./de/rechtliche-grundlagen.mdx": [
		57109,
		57109
	],
	"./en/imprint.mdx": [
		24984,
		24984
	],
	"./en/index.mdx": [
		83465,
		83465
	],
	"./en/legal-framework.mdx": [
		47707,
		47707
	],
	"./fr/cadre-juridique.mdx": [
		11325,
		11325
	],
	"./fr/impressum.mdx": [
		85967,
		85967
	],
	"./fr/index.mdx": [
		93817,
		93817
	],
	"./it/colophon.mdx": [
		1630,
		1630
	],
	"./it/index.mdx": [
		97058,
		97058
	],
	"./it/quadro-giuridico.mdx": [
		96391,
		96391
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 51058;
module.exports = webpackAsyncContext;